"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var NotFound_1 = require("../nav/route/NotFound");
var Route_1 = require("../nav/route/Route");
var Wrapper_1 = require("./Wrapper");
function App(_a) {
    var _b = _a.routes, routes = _b === void 0 ? [] : _b, HomeComponent = _a.HomeComponent, NotFoundComponent = _a.NotFoundComponent, identity = _a.identity, ui = _a.ui, layout = _a.layout;
    if (HomeComponent) {
        routes.unshift({ component: HomeComponent, exact: true, path: '/', privateRoute: false });
    }
    if (NotFoundComponent) {
        routes.push({ component: NotFoundComponent, privateRoute: false });
    }
    var routerContent = (react_1.default.createElement(react_router_dom_1.Switch, null, routes.map(function (route) { return Route_1.renderRoute(tslib_1.__assign({ layout: layout }, route)); })));
    if (NotFoundComponent) {
        var CaptureRouteNotFound = NotFound_1.useCaptureRouteNotFound(NotFoundComponent);
        routerContent = react_1.default.createElement(CaptureRouteNotFound, null, routerContent);
    }
    return react_1.default.createElement(Wrapper_1.Wrapper, { identity: identity, ui: ui, RouterComponent: react_router_dom_1.BrowserRouter, children: routerContent });
}
exports.App = App;
//# sourceMappingURL=App.js.map